/**
 * 将后端 UTC 时间字符串转为 Date 对象
 * 后端 isoformat() 不带 Z 后缀，需补上以正确解析为 UTC
 */
function parseUTCDate(dateStr: string): Date {
  if (dateStr.endsWith('Z') || /[+-]\d{2}:\d{2}$/.test(dateStr)) {
    return new Date(dateStr)
  }
  return new Date(dateStr + 'Z')
}

/**
 * 格式化日期时间（UTC → 本地时间）
 */
export function formatDateTime(dateStr: string | null | undefined): string {
  if (!dateStr) return '-'

  try {
    const date = parseUTCDate(dateStr)
    return date.toLocaleString('zh-CN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    })
  } catch (e) {
    return dateStr
  }
}

/**
 * 格式化日期（UTC → 本地时间）
 */
export function formatDate(dateStr: string | null | undefined): string {
  if (!dateStr) return '-'

  try {
    const date = parseUTCDate(dateStr)
    return date.toLocaleDateString('zh-CN')
  } catch (e) {
    return dateStr
  }
}

/**
 * 格式化相对时间（多久之前）
 */
export function formatRelativeTime(dateStr: string | null | undefined): string {
  if (!dateStr) return '-'

  try {
    const date = parseUTCDate(dateStr)
    const now = new Date()
    const diff = now.getTime() - date.getTime()

    const seconds = Math.floor(diff / 1000)
    const minutes = Math.floor(seconds / 60)
    const hours = Math.floor(minutes / 60)
    const days = Math.floor(hours / 24)

    if (days > 0) return `${days}天前`
    if (hours > 0) return `${hours}小时前`
    if (minutes > 0) return `${minutes}分钟前`
    return '刚刚'
  } catch (e) {
    return dateStr
  }
}
